import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import PractitionerConsentForm from './PractitionerConsentForm';

const ConsentModal = ({ open, onClose, practitionerName, consentVersion, dateSigned }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="consent-modal-title"
      aria-describedby="consent-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '90%', sm: 600 },
          maxHeight: '80vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          border: 'none',
          outline: 'none',
          overflowY: 'auto',
        }}
      >
        <Typography id="consent-modal-title" variant="h6" component="h2" gutterBottom>
          Practitioner Consent Agreement
        </Typography>
        <Box sx={{ mb: 3 }}>
          <PractitionerConsentForm practitionerName={practitionerName} />
        </Box>
        <Typography sx={{ mb: 3, fontStyle: 'italic' }}>
          Signed on: {dateSigned}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="contained" color="primary" onClick={onClose}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConsentModal;